import { Component } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CartService } from '../../../services/cart.service';
import { DrawerService } from '../../../services/drawer.service';

@Component({
  selector: 'app-shopping-cart-button',
  imports: [MatIconModule, MatButtonModule, MatBadgeModule],
  templateUrl: './shopping-cart-button.html',
  styleUrl: './shopping-cart-button.scss',
})
export class ShoppingCartButton {
  constructor(
    private drawerService: DrawerService,
    private cartService: CartService
  ) {}

  get quantity(): number {
    return this.cartService.quantity();
  }

  toggle() {
    this.drawerService.toggleCart();
  }
}
